// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { AssetFragmentDoc } from '../../../graphql/api/fragments/asset.fragment.generated';
import { MetalFilterMetalFragmentDoc } from '../../../graphql/api/product/rings/fragments/filters/metalFilter.fragment.generated';
import { MoneyFragmentDoc } from '../../../graphql/api/fragments/money.fragment.generated';
export const ProductPageMetaFragmentDoc = gql`
    fragment productPageMeta on CatalogueProduct {
  catalogueCode
  productName
  customTitleTag
  reviews {
    id
    name
    comment
    date
    rating
    picture {
      ...asset
    }
  }
  primaryMetal {
    ...metalFilterMetal
  }
  images {
    id
    url
  }
  salePrice(currency: $currency, region: $region) {
    total {
      ...money
    }
  }
  ... on CatalogueWeddingRing {
    translation(locale: $locale) {
      description
    }
    categories {
      systemCode
      translation(locale: $locale) {
        name
      }
    }
    wrRingStyles: ringStyles {
      systemCode
      translation(locale: $locale) {
        name
      }
    }
  }
  ... on CatalogueEngagementRing {
    erRingStyles: ringStyles {
      systemCode
      translation(locale: $locale) {
        name
      }
    }
    translation(locale: $locale) {
      description
    }
  }
  ... on CatalogueReadyToGoRing {
    sku
    translation(locale: $locale) {
      description
    }
  }
  ... on CatalogueJewelleryNecklace {
    translation(locale: $locale) {
      description
    }
  }
  ... on CatalogueJewelleryBracelet {
    translation(locale: $locale) {
      description
    }
  }
  ... on CatalogueJewelleryEarrings {
    translation(locale: $locale) {
      description
    }
  }
  ... on CatalogueJewelleryRing {
    translation(locale: $locale) {
      description
    }
  }
}
    ${AssetFragmentDoc}
${MetalFilterMetalFragmentDoc}
${MoneyFragmentDoc}`;